import { CSpinner } from '@coreui/react';
import React, { Component } from 'react';
import authen from '../../models/authen';

class AuthChecker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: null,
    };
    this.model = new authen();
    this.isRefreshing = false;
  }

  componentDidMount() {
    this.model.getUser().then(res => {
      if (res && res['result']) {
        window.user = res['data'];
        this.setState({ isAuthenticated: true });
      } else {
        this.checkAndRefreshToken().then(res => {
          if (res) {
            this.setState({ isAuthenticated: true });
          }
        })
      }
    });

    this.refreshTokenInterval = setInterval(() => {
      this.checkAndRefreshToken();
    }, 60 * 1000);

    window.addEventListener('focus', this.focusHandler);
  }

  focusHandler = () => {
    this.checkAndRefreshToken();
  }

  needRefreshTooken() {
    return !window.user || window.user.exp * 1000 - Date.now() < 30 * 60 * 1000
  }

  async checkAndRefreshToken() {
    console.log(Date() + ' check refresh token');
    if (this.isRefreshing) return true ;
    this.isRefreshing = true;
    try {

      if (!this.needRefreshTooken())
        return true ;

      console.log('refresh token');
      let res = await this.model.refreshToken();
      if (res) {
        window.user = res['user'];
        return true;
      }

    } finally {
      this.isRefreshing = false;
      console.log('refresh token done');
    }

    return false;
  }



  componentWillUnmount() {
    this.refreshTokenInterval && clearInterval(this.refreshTokenInterval);
  }


  render() {
    if (!this.state.isAuthenticated) {
      return (
        <div className="pt-3 text-center">
          <CSpinner color="primary" variant="grow" />
        </div>
      );
    }

    return this.props.children;
  }
}

export default AuthChecker;